import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MuiHeader from "./../../components/MuiHeader";

import { Divider, Paper, MenuList, MenuItem, ListItemText, ListItemIcon, Typography } from "@mui/material";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

function TemplateMaster() {
  const navigate = useNavigate();
  //  <Route path="/templatemaster_ece" element={<Ece />} />
  //         <Route path="/templatemaster_pge" element={<Pge />} />
  //         <Route path="/templatemaster_ppt" element={<Ppt />} />
  //         <Route path="/templatemaster_training" element={<Training />} />
  //         <Route path="/templatemaster_extra" element={<ExtraModules />} />
  // < Route path = "/templatemaster_demo" element = {< Demo />} />
  const navigateto = (path) => {
    navigate(path);
  };

  return (
    <>
      <div>
        <MuiHeader header="Template Master" />

        <div className="menu-center">
          <div>
            <div>
              <h2>Select Module</h2>
            </div>
            <div className="menu-container">
              <Paper sx={{ width: 320, maxWidth: "100%" }}>
                <MenuList>
                  <MenuItem onClick={() => navigateto("/templatemaster_ece")}>
                    <ArrowRightIcon />
                    <ListItemText>ECE Activity</ListItemText>
                  </MenuItem>

                  <MenuItem onClick={() => navigateto("/templatemaster_pge")}>
                    <ArrowRightIcon />
                    <ListItemText>PGE Activity</ListItemText>
                  </MenuItem>

                  <Divider />
                  <MenuItem onClick={() => navigateto("/templatemaster_ppt")}>
                    <ArrowRightIcon />
                    <ListItemText>PPT</ListItemText>
                  </MenuItem>

                  <MenuItem onClick={() => navigateto("/templatemaster_training")}>
                    <ArrowRightIcon />
                    <ListItemText>Training</ListItemText>
                  </MenuItem>

                  <Divider />
                  <MenuItem onClick={() => navigateto("/templatemaster_extra")}>
                    <ArrowRightIcon />
                    <ListItemText>Extra Modules</ListItemText>
                  </MenuItem>

                  <MenuItem onClick={() => navigateto("/templatemaster_demo")}>
                    <ArrowRightIcon />
                    <ListItemText>Demo</ListItemText>
                  </MenuItem>
                </MenuList>
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TemplateMaster;
